/* IntegratedHeader — top bar on Mobile Landing page.
   Brand-first: LEXIQ wordmark + tagline (center) with a small animated
   Iraqi flag pinned to the start (right in RTL), and the notification
   bell pinned to the end (left in RTL) for authenticated users. */
import { Link } from "react-router-dom";
import { CalendarBlank } from "@phosphor-icons/react";
import LexiqWordmark from "../LexiqWordmark";
import IraqFlag from "../IraqFlag";
import NotificationBell from "../notifications/NotificationBell";
import { useUser } from "../../context/UserAuthContext";

export default function IntegratedHeader() {
  const { user } = useUser();
  return (
    <header
      className="relative flex items-center justify-between mb-5"
      data-testid="landing-header"
    >
      {/* Right (start in RTL) — animated Iraqi flag → دليل المحامين */}
      <Link
        to="/lawyers"
        aria-label="دليل محامي العراق"
        data-testid="flag-to-directory"
        className="relative group active:scale-95 transition"
      >
        <IraqFlag className="w-[48px] h-[30px]" testid="landing-iraq-flag" />
        <span className="absolute -bottom-4 right-1/2 translate-x-1/2 text-[9px] font-tajawal text-[#5A6470] whitespace-nowrap opacity-80 group-hover:opacity-100">
          المحامون
        </span>
      </Link>

      {/* Center — LEXIQ brand wordmark + tagline */}
      <div className="flex-1 text-center px-3">
        <LexiqWordmark className="text-[32px]" testid="landing-lexiq-wordmark" />
        <p className="text-[13px] font-tajawal text-[#5A6470] mt-1 leading-snug">
          ذكاءٌ قانوني، بمنطقِ القاضي ودقّةِ المحامي
        </p>
      </div>

      {/* Left (end in RTL) — notification bell + timeline icon (stacked) for authenticated users */}
      <div className="min-w-[48px] flex flex-col items-center justify-center gap-2" aria-hidden={!user}>
        {user ? (
          <>
            <NotificationBell />
            <Link
              to="/timeline"
              aria-label="الجدول الزَّمني"
              data-testid="header-timeline-link"
              className="w-10 h-10 rounded-full bg-white border border-[#EFEFEF] shadow-[0_2px_8px_rgba(10,25,47,0.06)] flex items-center justify-center active:scale-95 transition hover:border-[#D4AF37]"
            >
              <CalendarBlank size={18} weight="duotone" className="text-[#0A192F]" />
            </Link>
          </>
        ) : null}
      </div>
    </header>
  );
}
